import { Transition } from '@headlessui/react'
import { useTranslation } from 'react-i18next'
import { InputProps } from 'components/ui/Input'
import { useId, useState } from 'react'
import { Icon } from 'components/ui/Icon'
import { inputClasses, labelClasses } from 'components/ui/inputClasses'

export const InputPassword = ({ value, setValue, label, error, ...rest }: InputProps) => {
  const [showPassword, setShowPassword] = useState(false)

  const { t } = useTranslation()
  const id = useId()
  const errorId = `${id}-error`
  return (
    <div className={'tw-flex tw-flex-col'}>
      <label htmlFor={id} className={labelClasses}>
        {label}
      </label>
      <div className={'tw-relative'}>
        <input
          id={id}
          placeholder={label}
          aria-invalid={!!error}
          aria-describedby={error ? errorId : undefined}
          className={inputClasses(!!error, 'tw-h-11 tw-pr-11')}
          type={showPassword ? 'text' : 'password'}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          {...rest}
        />
        <button
          type="button"
          aria-label={showPassword ? t('hidePassword') : t('showPassword')}
          aria-pressed={showPassword}
          onClick={() => setShowPassword(!showPassword)}
          className={
            '-tw-translate-y-1/2 tw-absolute tw-right-1.5 tw-top-1/2 tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-md tw-text-[var(--text-tertiary)] tw-transition-colors hover:tw-text-[var(--text-primary)]'
          }
        >
          <Icon aria-hidden icon={['far', showPassword ? 'eye-slash' : 'eye']} />
        </button>
      </div>
      <Transition
        show={!!error}
        enter="tw-transition-opacity tw-duration-300"
        enterFrom="tw-opacity-0"
        enterTo="tw-opacity-100"
        leave="tw-transition-opacity tw-duration-300"
        leaveFrom="tw-opacity-100"
        leaveTo="tw-opacity-0"
        className={'tw-mt-1 tw-text-xs tw-text-red-600'}
      >
        <span id={errorId} role="alert">
          {error ? t(error) : null}
        </span>
      </Transition>
    </div>
  )
}
